import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function LayoutMaquinista({ children }) {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path) => location.pathname === path;

  const navItem = (to, icon, label) => (
    <Link to={to} style={{
      display: 'flex', alignItems: 'center', gap: 12, padding: '12px 16px',
      borderRadius: 10, marginBottom: 4, textDecoration: 'none',
      background: isActive(to) ? '#f0f0f0' : 'transparent',
      color: isActive(to) ? '#1a1a1a' : '#555',
      fontWeight: isActive(to) ? 500 : 400, fontSize: 15
    }}>
      <span style={{ fontSize: 20 }}>{icon}</span>
      <span>{label}</span>
    </Link>
  );

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: '#f5f4f0' }}>

      {/* Overlay móvil */}
      {mobileOpen && (
        <div onClick={() => setMobileOpen(false)} style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: 99
        }} />
      )}

      {/* Barra lateral */}
      {(!isMobile || mobileOpen) && (
        <aside style={{
          width: 240, background: '#fff', borderRight: '1px solid #e5e5e5',
          display: 'flex', flexDirection: 'column',
          position: isMobile ? 'fixed' : 'relative',
          height: '100vh', zIndex: 100,
          top: 0, left: 0
        }}>
          {/* Cabecera */}
          <div style={{ padding: '20px 16px', borderBottom: '1px solid #e5e5e5' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <img src='/loconode-small.png' alt='Loconode' style={{ height: 28, width: 'auto' }} />
              <span style={{ fontWeight: 600, fontSize: 15, color: '#1a1a1a' }}>Loconode</span>
            </div>
            <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>{usuario?.nombre} {usuario?.apellidos}</div>
          </div>

          {/* Navegación */}
          <nav style={{ flex: 1, padding: '12px 8px', overflowY: 'auto' }}>
            {navItem('/maquinista/inicio', '🏠', 'Inicio')}
            {navItem('/maquinista/proximos', '📅', 'Próximos servicios')}
            {navItem('/maquinista/habilitaciones', '📋', 'Habilitaciones')}
            {navItem('/maquinista/documentacion', '📄', 'Documentación')}
          </nav>

          {/* Cerrar sesión */}
          <div style={{ padding: 12, borderTop: '1px solid #e5e5e5' }}>
            <button onClick={() => { logout(); navigate('/login'); }} style={{
              width: '100%', padding: '10px', borderRadius: 8, border: '1px solid #e5e5e5',
              background: 'transparent', cursor: 'pointer', fontSize: 14, color: '#555'
            }}>
              Cerrar sesión
            </button>
          </div>
        </aside>
      )}

      {/* Botón hamburguesa móvil */}
      {isMobile && !mobileOpen && (
        <button onClick={() => setMobileOpen(true)} style={{
          position: 'fixed', top: 12, left: 12, zIndex: 101,
          background: '#fff', border: '1px solid #e5e5e5', borderRadius: 8,
          padding: '8px 10px', cursor: 'pointer', fontSize: 18,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>☰</button>
      )}

      {/* Contenido */}
      <main style={{
        flex: 1, padding: isMobile ? '56px 16px 24px' : 24,
        maxWidth: isMobile ? '100%' : 600, margin: '0 auto'
      }}>
        {children}
      </main>
    </div>
  );
}
